import axios from 'axios';
import { REVALIDATE_API } from 'constants/endpoints';

const clearCaching = async (options) => {
    try {
        const url = `${process.env.REACT_APP_HEXAHOME_BASE_URL}${REVALIDATE_API}`
        await axios.post(url, options,{
            headers: {
              Origin: window.location.origin,
            }
        });
        return;
    } catch (error) {
        console.error('Error:', error);
    }
}
export default clearCaching